import { Typography } from '@sravni/react-design-system';
import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Space } from '@sravni/react-design-system/lib/Space';
import { useIsPhone } from '@sravni/react-utils';

import cupSrc from '@src/assets/octoberPrizeDraw/cup.png';
import mobileCupSrc from '@src/assets/octoberPrizeDraw/mobileCup.png';
import { getHiddenPhoneNumber } from '@src/components/OctoberPrizeDraw/utils';
import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';

import { OZON_PRIZE_TEXT } from '../constants';

import { MAIN_WINNER } from './constants';
import styles from './styles.module.scss';

const { Text, Heading } = Typography;

export const MainWinner = () => {
  const isPhone = useIsPhone();
  const hiddenPhoneNumber = getHiddenPhoneNumber(MAIN_WINNER.phoneNumber);
  const text = `Победитель ${hiddenPhoneNumber}`;

  if (isPhone) {
    return (
      <Space className={styles.cardMobile} direction="vertical">
        <div className={styles.topBlock}>
          <OptimizedPicture imgClassName={styles.winner} img={MAIN_WINNER.avatarSrc} alt="" />
          <div className={styles.topTextBlock}>
            <Text className={styles.cardTitle} size={12}>
              {OZON_PRIZE_TEXT}
            </Text>
            <Badge text={MAIN_WINNER.amount} color="green" variant="primary" />
          </div>
        </div>

        <div className={styles.bottomBlock}>
          <div className={styles.textContentMobile}>
            <Heading className={styles.winnerInfo} level={3}>
              <span>Победитель</span>
              <br />
              <span>{hiddenPhoneNumber}</span>
            </Heading>
            {MAIN_WINNER.fio && <div className={styles.fio}>{MAIN_WINNER.fio}</div>}
          </div>

          <OptimizedPicture imgClassName={styles.cup} img={mobileCupSrc} alt="" />
        </div>
      </Space>
    );
  }

  return (
    <Space className={styles.card}>
      <OptimizedPicture imgClassName={styles.winner} img={MAIN_WINNER.avatarSrc} alt="" />

      <div className={styles.textContent}>
        <div className={styles.title}>
          <Text className={styles.cardTitle} size={12}>
            {OZON_PRIZE_TEXT}
          </Text>
          <Badge text={MAIN_WINNER.amount} color="green" variant="primary" />
        </div>

        <Heading className={styles.winnerInfo} level={3}>
          {text}
        </Heading>

        {MAIN_WINNER.fio && <div className={styles.fio}>{MAIN_WINNER.fio}</div>}
      </div>

      <OptimizedPicture imgClassName={styles.cup} img={cupSrc} alt="" />
    </Space>
  );
};
